import YTPlayer from '../../scripts/components/YTPlayer';

export function initWebinarIndividualYtPlayer(actionClass) {
  return YTPlayer.init(
    '#webinar-individual-ytplayer',
    '#webinar-individual-ytplayer-frame',
    actionClass
  );
}
